// extracted by mini-css-extract-plugin
module.exports = {"root":"Ie1gr"};